var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2443_141664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.93333 17.0578H7.56667V16.4245H6.93333V17.0578ZM6.93333 20.8553H6.3C6.3 20.9729 6.33275 21.0882 6.39459 21.1882C6.45642 21.2883 6.5449 21.3691 6.6501 21.4217C6.7553 21.4743 6.87307 21.4966 6.99021 21.486C7.10735 21.4755 7.21924 21.4325 7.31333 21.3619L6.93333 20.8553ZM12 17.0578V16.4245H11.7885L11.62 16.5511L12 17.0578ZM8.2 7.56287H7.56667V8.82953H8.2V7.56287ZM15.8 8.82953H16.4333V7.56287H15.8V8.82953ZM8.2 11.3603H7.56667V12.627H8.2V11.3603ZM13.2667 12.627H13.9V11.3603H13.2667V12.627ZM6.3 17.0578V20.8553H7.56667V17.0578H6.3ZM7.31333 21.3619L12.38 17.5645L11.62 16.5511L6.55333 20.3486L7.31333 21.3619ZM12 17.6911H19.6V16.4245H12V17.6911ZM19.6 17.6911C20.6501 17.6911 21.5 16.8425 21.5 15.7911H20.2333C20.2333 16.142 19.9509 16.4245 19.6 16.4245V17.6911ZM21.5 15.7911V4.4H20.2333V15.7924H21.5V15.7911ZM21.5 4.4C21.5 3.34867 20.6501 2.5 19.6 2.5V3.76667C19.9509 3.76667 20.2333 4.04913 20.2333 4.4H21.5ZM19.6 2.5H4.4V3.76667H19.6V2.5ZM4.4 2.5C3.34993 2.5 2.5 3.34867 2.5 4.4H3.76667C3.76667 4.04913 4.04913 3.76667 4.4 3.76667V2.5ZM2.5 4.4V15.7911H3.76667V4.4H2.5ZM2.5 15.7911C2.5 16.8425 3.34993 17.6911 4.4 17.6911V16.4245C4.31678 16.4246 4.23435 16.4084 4.15744 16.3766C4.08052 16.3448 4.01064 16.2982 3.95179 16.2393C3.89295 16.1805 3.84631 16.1106 3.81454 16.0337C3.78277 15.9568 3.7665 15.8744 3.76667 15.7911H2.5ZM4.4 17.6911H6.93333V16.4245H4.4V17.6911ZM8.2 8.82953H15.8V7.56287H8.2V8.82953ZM8.2 12.627H13.2667V11.3603H8.2V12.627Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2443_141664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(2.5 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.49144b4a3a1a490ac57ab1e2aa2c8e30.svg";
export { ForwardRef as ReactComponent };